module.exports = __webpack_public_path__ + "img/header_dsk.1627e4d.webp";